import { Controller } from '@hotwired/stimulus';

// Dynamic import: keeps Highcharts out of the eagerly-loaded controllers
// bundle (shipped on every page) since this controller is only used where
// a chart actually renders.
export default class extends Controller {
  static targets = ['container'];
  // `decimals` applies to emission values (EmissionPrecisionHelper#emission_chart_decimals).
  static values = { options: Object, decimals: { type: Number, default: 2 } };

  async connect() {
    const { default: Highcharts } = await import('highcharts');
    this.highcharts = Highcharts;

    const options = this.customizeLabel(this.optionsValue);
    Highcharts.chart(this.containerTarget, options);
  }

  decimalPoint() {
    return this.optionsValue.lang.decimalPoint || '.';
  }

  thousandsSep() {
    return this.optionsValue.lang.thousandsSep || ',';
  }

  formatEmission(value) {
    return this.highcharts.numberFormat(
      value,
      this.decimalsValue,
      this.decimalPoint(),
      this.thousandsSep()
    );
  }

  customizeLabel(options) {
    if (options.chart.type != 'pie') {
      return this.customizeStackLabel(options);
    }

    const decimalPoint = this.decimalPoint();
    const thousandsSep = this.thousandsSep();
    const highcharts = this.highcharts;

    const formatEmission = this.formatEmission.bind(this);

    options.legend.labelFormatter = function () {
      const formattedY = highcharts.numberFormat(this.y, 2, decimalPoint, thousandsSep);
      const formattedQuantity = formatEmission(this.options.quantity);

      return `${this.name.toUpperCase()} ${formattedQuantity} (${formattedY}%)`;
    };

    return options;
  }

  customizeStackLabel(options) {
    const formatEmission = this.formatEmission.bind(this);

    if (options.plotOptions.column == undefined || options.yAxis[0].stackLabels == undefined)
      return options;

    if (!options.plotOptions.column.stacking) {
      options.series.forEach((serie) => {
        serie.dataLabels = {
          enabled: true,
          formatter: function () {
            return formatEmission(this.y);
          },
        };
      });
    }

    options.yAxis[0].stackLabels.formatter = function () {
      return formatEmission(this.total);
    };

    return options;
  }
}
